import React, { useState } from "react";
import { FormControlLabel, Checkbox, Card, Box, Typography, Button } from "@mui/material";

const TestCases = ({ testType, testCases, selectedTestCases, setSelectedTestCases }) => {
  const isSelected = (testCase) =>
    selectedTestCases.some((tc) => tc.id === testCase.id);

  const filteredTestCases = testType === "browser"
    ? testCases.filter(tc => tc.type === "browser")
    : testCases.filter(tc => tc.type !== "browser");

  const handleTestCaseToggle = (testCase) => {
    if (isSelected(testCase)) {
      setSelectedTestCases(selectedTestCases.filter((tc) => tc.id !== testCase.id));
    } else {
      setSelectedTestCases([...selectedTestCases, testCase]);
    }
  };

  const handleSelectAll = () => {
    if (selectedTestCases.length === filteredTestCases.length) {
      setSelectedTestCases([]);
    } else {
      setSelectedTestCases([...filteredTestCases]);
    }
  };

  return (
    <Card className="test-cases-card"  style={{overflowY:filteredTestCases?.length > 6 ? "scroll" :""}}>
      <Box display="flex" justifyContent="space-between" alignItems="center" className="test-cases-head">
        <Typography variant="h6" className="section-title">
          Select Manually Test Cases
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className="select-all-button"
          onClick={handleSelectAll}
        >
          Select All
        </Button>
      </Box>

      <div className="test-cases-list">
        {filteredTestCases.map((testCase) => (
          <div key={testCase.id} className="test-case-item">
            <FormControlLabel
              control={
                <Checkbox
                  checked={isSelected(testCase)}
                  onChange={() => handleTestCaseToggle(testCase)}
                  color="primary"
                />
              }
              label={testCase.description}
            />
          </div>
        ))}
      </div>
    </Card>
  );
};


export default TestCases;
